const BANNER_IMG =
  "https://customer-assets.emergentagent.com/job_austin-yard-pro/artifacts/42ffcu8g_IMG_5490.png";

export default function BattleBanner() {
  return (
    <section
      id="battle-banner"
      data-testid="battle-banner-section"
      className="relative bg-black py-12 md:py-16 border-t border-b border-border"
    >
      <div className="container-ic">
        <a
          href="#booking"
          className="block group relative overflow-hidden"
          data-testid="battle-banner-link"
          aria-label="Built for battle. Ready for your yard. Book Ironclad."
        >
          <div className="relative w-full aspect-[3/1] md:aspect-[4/1] overflow-hidden">
            <img
              src={BANNER_IMG}
              alt="Built for Battle. Ready for Your Yard. — Ironclad Yard Services"
              className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.02]"
            />
            {/* Subtle sheen on hover */}
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/5 transition-colors duration-500 pointer-events-none" />
          </div>
        </a>
      </div>
    </section>
  );
}
